module.exports = __webpack_public_path__ + "static/media/zuikaku-lose.5c57badc.png";